module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAATCAYAAACgADyUAAABRklEQVQ4jY3RPWtUURDG8d8m10TQqJ0QiIWFn0IQcfAFLBNMYyCNH8HODxFIZRXE1kItBO9gais7CxsbMWkUTCFuVrMW964eDht2Bw6cM3P+88zLoG3bm3iJFfPZCJsN3uEVdrAwAzrBQ7xoesc3rM6p+AOa/rKFzTkVz+CowUVsR8TePHKZeRdvJgqzlGpVkx6HmbmADSxWHw8iYr94ny3B7/39GZYqsMV+5ftX4lpEHOOCbp/n+7OCe9PqnSguQUQMMTytud6WS/AwMxex2/dwUn0e4Dce40sJ/urLvoNzGE8Bh3iCnyV4JSJGuDqjTJl5nf/DGc0CChuV4LTMtzLz/mnxqWBmXkPidWbeqMLjEjwsIxHxCR/wEe8r8CsM2rYd4y2e6qZHN+XLup191k16oraBBw3W8Ry3q8xHun1eqvx/8OgvyntT1JLOIX4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/apps/40.png
// module id = 4NaA
// module chunks = 0